import React, { useState, useEffect } from 'react';
import axios from '../../axios'; // Adjust the import based on your file structure
import Select from 'react-select';
import { components } from 'react-select';

// Custom menu component without infinite scrolling
const CustomMenuList = (props) => {
  const { children } = props;

  return (
    <components.MenuList {...props} className="custom-menu-list">
      {children} {/* Render all children */}
    </components.MenuList>
  );
};

// Component to handle multi-select course dropdown
const MultiSelectCourseDropdown = ({ selectedCourses, onChange, isDisabled, imp }) => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);

  // Fetch courses from the API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.post('/scheme/getall');
        setCourses(response.data);
      } catch (error) {
        setError('Error fetching schemes.');
        console.error('Error fetching schemes:', error);
      }
    };

    fetchCourses();
  }, []);

  // Transform course data for react-select
  const options = courses.map(course => ({
    value: course.scheme_id,
    label: course.scheme_name,
  }));

  // Handle change event from react-select
  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    onChange(selectedValues);
  };

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Schemes Name {imp && <span className="text-red-500">*</span>}
      </label>
      <Select
        isMulti
        options={options}
        value={options.filter(option => selectedCourses && selectedCourses.includes(option.value))}
        onChange={handleChange}
        isDisabled={isDisabled}
        className={`basic-single ${error ? 'border-red-600' : ''}`}
        classNamePrefix="Select"
        components={{ MenuList: CustomMenuList }}
      />
      {error && <p className="text-red-500">{error}</p>}
      <style jsx>{`
        .custom-menu-list {
          max-height: 200px; /* Adjust height as needed */
          overflow-y: auto; /* Show scrollbar when needed */
          border: 1px solid skyblue;
          border-radius: 7px;
          padding: 0;
        }
      `}</style>
    </div>
  );
};

export default MultiSelectCourseDropdown;
